export enum SubmissionState {
  Unsubmitted,
  Submitting,
  SubmissionError,
  RequiresAction,
}

interface Unsubmitted {
  state: SubmissionState.Unsubmitted;
}

interface Submitting {
  state: SubmissionState.Submitting;
}

interface SubmissionError {
  state: SubmissionState.SubmissionError;
  error?: string;
}

interface RequiresAction {
  state: SubmissionState.RequiresAction;
  actionUrl: string;
}

export type Submission =
  | Unsubmitted
  | Submitting
  | SubmissionError
  | RequiresAction;
